import React, { useState } from "react";
import Styles from "../styles/Styles";
import {
  TablePagination,
  Table,
  IconButtonContained,
  Input,
  InputSearch,
  CustomText,
} from "../../../components";
import { Colors, Spacing, fonts } from "../../../config";
import { Texts } from "../../../config";
import { CircularProgress, Grid } from "@material-ui/core";
import { Check, Clear, Edit, Visibility } from "@material-ui/icons";
import { FormFull } from "form-full";
import { api } from "../../../services";
import { hooks, masks } from "../../../utils";
import { customModal, errorModal } from "../../../components/modals/utils";
import alerts from "../../../utils/Alerts";
import ResponseError from "../../../services/helpers/ResponseError";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { MdOutlineRemoveRedEye } from "react-icons/md";

type DepositsTableProps = {
  transactions: any;

  getAllDeposits: any;
  page: any;
  setPage: any;
  sendSelectedFilter: any;
  filterValue: any;
  currentButton: any;
  loadingData: any;
  setCurrentButton: any;
  size: any;
};

function DepositsTable({
  transactions,

  getAllDeposits,
  page,
  setPage,
  sendSelectedFilter,
  filterValue,
  currentButton,
  loadingData,
  setCurrentButton,
  size,
}: DepositsTableProps) {
  const texts = Texts["pt-BR"].Main.UsersStatement;

  const { loading, call } = hooks.useRequest();

  const Status = (data?: string) => {
    if (data === "OVERDUE") {
      return (
        <Styles.StatusContainer $disabled>Atrasado</Styles.StatusContainer>
      );
    } else if (data === "PENDING") {
      return (
        <Styles.StatusContainer $disabled>Pendente</Styles.StatusContainer>
      );
    } else if (data === "REJECTED") {
      return (
        <Styles.StatusContainer $disabled>Rejeitado</Styles.StatusContainer>
      );
    } else if (data === "INACTIVE") {
      return <Styles.StatusContainer $disabled>Inativo</Styles.StatusContainer>;
    } else if (data === "PAID" || data === "ACCEPTED") {
      return <Styles.StatusContainer>Estornado</Styles.StatusContainer>;
    } else if (data === "PROCESSING") {
      return <Styles.StatusContainer $disabled>Em andamento</Styles.StatusContainer>;
    }
  };

  const acceptRefund = (refundId: string) => {
    const refund = transactions?.content.find((item) => item.id === refundId);
    const paymentId = refund.transaction.id;

    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    call(null, api.getPaymentLink(paymentId), (data) => {
      if (data.ok) {
        window.open(data.data.invoiceUrl, "_blank");
        customModal.setInfos(
          "Sucesso!",
          [],
          {
            onClick: () => window.open(data.data.invoiceUrl, "_blank"),
            label: "Ir ao Site",
          },
          null,
          <div style={{ paddingInline: "22px", paddingBlock: "16px" }}>
            <CustomText>
              Processo para o estorno iniciado. Redirecionando para:
            </CustomText>
            <CustomText
              textColor="blue"
              style={{ textDecoration: "underline", paddingTop: "12px" }}
            >
              <a href={data?.data?.invoiceUrl} target="_blank">
                {data?.data?.invoiceUrl}
              </a>
            </CustomText>
          </div>
        );
      } else {
        const errorResponse = new ResponseError(data);
        errorResponse.alertMessage();
      }
    });
  };

  const denyRefund = (refundId: string) => {
    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    call(null, api.denyRefund(refundId), (data) => {
      if (data.ok) {
        setPage(page);
      } else {
        const errorResponse = new ResponseError(data);
        errorResponse.alertMessage();
      }
    });
  };

  const paymentMethod = (method: string) => {
    if (method === "BILLET") {
      return "Boleto";
    } else if (method === "PIX") {
      return "PIX";
    } else if (method === "CREDIT_CARD") {
      return "Cartão de Crédito";
    } else if (method === "DEBIT_CARD") {
      return "Cartão de Débito";
    } else {
      return null;
    }
  };

  const modalList = (data: any) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {data?.map((item) => {
          return (
            <Styles.ListItem>
              <Styles.ListText $label>{item.label}</Styles.ListText>
              <Styles.ListText>{item.value}</Styles.ListText>
            </Styles.ListItem>
          );
        })}
      </div>
    );
  };

  const modalContent = (idDeposity: string, isPending: boolean) => {
    return (
      <>
        <Styles.DeposityModalContainer>
          <Styles.DeposityModalTitle>Estorno</Styles.DeposityModalTitle>
          <Styles.DeposityModalContent>
            {transactions?.content.map((item) => {
              if (item?.id === idDeposity) {
                let data = [
                  {
                    label: "Nome",
                    value: item?.transaction?.user?.name,
                  },
                  {
                    label: "CPF",
                    value: masks.CPF(item?.transaction?.user?.cpf),
                  },
                  {
                    label: "E-mail",
                    value: item?.transaction?.user?.email,
                  },
                  {
                    label: "Data",
                    value: masks.formatDate(item?.createdAt.split("T")[0]),
                  },
                  {
                    label: "N° Pedido",
                    value: item?.transaction?.asaasId
                      ? item?.transaction?.asaasId
                      : "Dado não encontrado",
                  },
                  {
                    label: "Forma de Pagamento",
                    value: item?.transaction
                      ? paymentMethod(item?.transaction?.method)
                      : "Dado não encontrado",
                  },
                  {
                    label: "Status",
                    value: Status(item?.status),
                  },
                  {
                    label: "Dado Total",
                    value: item?.transaction?.value?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }),
                  },
                  {
                    label: "Motivo",
                    value: item?.motive ? item?.motive : "Sem Motivo",
                  },
                ];
                return modalList(data);
              }
            })}
          </Styles.DeposityModalContent>
          <div
            style={{
              marginTop: 20,
            }}
          >
            {isPending ? (
              <>
                <Styles.DeposityModalButtons>
                  <Styles.ApproveButton
                    startIcon={<CheckIcon />}
                    onClick={() => {
                      acceptRefund(idDeposity);
                    }}
                  >
                    Aprovar
                  </Styles.ApproveButton>
                  <Styles.DisapproveButton
                    startIcon={<CloseIcon />}
                    onClick={() => {
                      denyRefund(idDeposity);
                    }}
                  >
                    Negar
                  </Styles.DisapproveButton>
                  <Styles.CloseButton onClick={customModal.close}>
                    Fechar
                  </Styles.CloseButton>
                </Styles.DeposityModalButtons>
              </>
            ) : (
              <>
                <Styles.CloseButton onClick={customModal.close}>
                  Fechar
                </Styles.CloseButton>
              </>
            )}
          </div>
        </Styles.DeposityModalContainer>
      </>
    );
  };

  const seeDeposity = (idDeposity: string, isPending: boolean) => {

    customModal.setInfos(
      "",
      [""],
      null,
      null,
      modalContent(idDeposity, isPending),
      true,
      null
    );
  };

  const formatDate = (date: string) => {
    let getDate = date.split("T");
    let getTime = getDate[1].split(".");
    return (
      <>
        {getDate[0]} {getTime[0]}
      </>
    );
  };

  const onChangeFilterSubmit = (pageNumber, selectedFilter) => {
    filterValue.current = selectedFilter;
    sendSelectedFilter(pageNumber, selectedFilter);
  };

  const getCurrentTable = (pageNumber, status) => {
    getAllDeposits(pageNumber, status);
  };

  const NoData = () => {
    return (
      <Styles.NoDataContainer>
        <Styles.NoDataText>{"Sem Dados"}</Styles.NoDataText>
      </Styles.NoDataContainer>
    );
  };

  return (
    <>
      <Styles.Container>
        {loadingData ? (
          <Styles.LoadingContainer>
            <CircularProgress
              size={120}
              style={{
                color: "black",
                alignSelf: "center",
                justifyContent: "center",
                marginBlock: Spacing(3),
              }}
            />
          </Styles.LoadingContainer>
        ) : (
          <>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid container spacing={2} item xs={12} sm={12} md={12} lg={6}>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                  <Styles.ButtonFilter
                    $focus={currentButton === "all"}
                    onClick={() => {
                      getCurrentTable(0, "");
                      setCurrentButton("all");
                    }}
                  >
                    {texts.allButton}
                  </Styles.ButtonFilter>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                  <Styles.ButtonFilter
                    $focus={currentButton === "pending"}
                    onClick={() => {
                      getCurrentTable(0, "PENDING");
                      setCurrentButton("pending");
                    }}
                  >
                    {texts.pendingButton}
                  </Styles.ButtonFilter>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                  <Styles.ButtonFilter
                    $focus={currentButton === "completed"}
                    onClick={() => {
                      getCurrentTable(0, "ACCEPTED");
                      setCurrentButton("completed");
                    }}
                  >
                    {texts.approvedButton}
                  </Styles.ButtonFilter>
                </Grid>
              </Grid>
            </Grid>
            {transactions ? (
              <TablePagination
                defaultAlignItems
                size={size}
                page={page}
                setPage={setPage}
                itemRowPages={transactions?.content.length}
                totalPages={transactions?.totalPages}
                totalRowPages={transactions?.totalElements}
                headerTable={
                  <Styles.HeaderTable>
                    <InputSearch
                      onEnterKeyPress={(data) => onChangeFilterSubmit(0, data)}
                    />
                  </Styles.HeaderTable>
                }
                table={
                  <Table
                    id="DepositsTable"
                    data={transactions?.content}
                    headers={texts.headerTable}
                    lastAlign={false}
                    firstColumn={false}
                    renderItemColumns={(item) => [
                      formatDate(item.createdAt),

                      item.transaction?.asaasId
                        ? item.transaction?.asaasId
                        : "Dado não encontrado",

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <p style={{ margin: 0 }}>
                          {item.transaction?.user?.email}
                        </p>
                        <p style={{ margin: 0 }}>
                          {masks.CPF(item.transaction?.user?.cpf)}
                        </p>
                      </div>,

                      item.transaction?.value?.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }),

                      item.transaction?.method ? (
                        <p style={{ margin: 0, fontFamily: fonts.bold }}>
                          {paymentMethod(item.transaction?.method)}
                        </p>
                      ) : (
                        <p style={{ fontFamily: fonts.bold }}>
                          Dado não encontrado
                        </p>
                      ),

                      Status(item?.status),

                      <Styles.AreaButtonsTable>
                        <>
                          {item.status === "PENDING" ? (
                            <>
                              <IconButtonContained
                                loading={loading}
                                disabled={loading}
                                changeColor={Colors.blue}
                                Icon={<MdOutlineRemoveRedEye />}
                                changeIconColor={Colors.white}
                                onClick={() => seeDeposity(item?.id, item.status === "PENDING")}
                              />
                              <IconButtonContained
                                loading={loading}
                                disabled={loading}
                                changeColor={Colors.green}
                                Icon={<CheckIcon />}
                                changeIconColor={Colors.white}
                                onClick={() => acceptRefund(item?.id)}
                              />
                              <IconButtonContained
                                loading={loading}
                                disabled={loading}
                                changeColor={Colors.red}
                                Icon={<Clear />}
                                changeIconColor={Colors.white}
                                onClick={() => denyRefund(item?.id)}
                              />
                            </>
                          ) : (
                            <>
                              <IconButtonContained
                                loading={loading}
                                disabled={loading}
                                changeColor={Colors.blue}
                                Icon={<MdOutlineRemoveRedEye />}
                                changeIconColor={Colors.white}
                                onClick={() => seeDeposity(item?.id, false)}
                              />
                            </>
                          )}
                        </>
                      </Styles.AreaButtonsTable>,
                    ]}
                  />
                }
              />
            ) : (
              <>{NoData()}</>
            )}
          </>
        )}
      </Styles.Container>
    </>
  );
}

export default DepositsTable;
